import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { userLoginOAuth2 } from '../../../Reducers/Auth/actions'
import { authorization } from '../../../Module/Auth/Auth'
import { useWrappedPosthog } from '../../../Components/PostHogProvider/hooks'
import { decrypt } from '../../../Utils/Encryption'
import { ExternalOAuthSuccess } from '../components/ExternalOAuthSuccess'

const AuthCallback = () => {
  const dispatch = useDispatch()
  const posthog = useWrappedPosthog()

  const params = new URLSearchParams(window.location.search)
  const email = params.get('email')
  const encryptedApiKey = params.get('apiKey')
  const source = params.get('source')
  const decryptedApiKey = decrypt(encryptedApiKey)

  const isExternalSource = source === 'figma'

  if (decryptedApiKey && email) {
    localStorage.setItem('apiKey', decryptedApiKey)
    dispatch(userLoginOAuth2(email))
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (authorization.isLogged()) {
        if (posthog) {
          posthog.capture('Logged in From Social Login', {
            'event_action':
              'Users click on the "Social Login" Button for Login',
            'event_category': 'Social Login',
          })
        }
        window.close()
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  if (isExternalSource) {
    return <ExternalOAuthSuccess toolName="Figma" />
  }

  return <div />
}

export default AuthCallback
